<template>
  <div>
    <Field
      v-slot="{ errors, field, value }"
      v-model="_origin"
      :name="$filters.formLabelValidation($t('ETAB.PAGES.SIGNUP.STEPS.MAIN.ORIGIN.@TITLE'))"
      :rules="'required'"
    >
      <QField v-bind="field" :model-value="value" borderless :error="errors.length > 0" :error-message="errors[0]">
        <QList class="full-width">
          <QItem v-for="input in inputValues" :key="input.value" tag="label">
            <QItemSection avatar>
              <QRadio v-model="_origin" :val="input.value" type="radio" />
            </QItemSection>
            <QItemSection>
              <QItemLabel>{{ $t(input.label) }}</QItemLabel>
            </QItemSection>
          </QItem>
        </QList>
      </QField>
    </Field>
    <div v-if="_origin == OTHER">
      <Field
        v-slot="{ errors, field, value }"
        v-model="_otherValue"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.ORIGINS.@OTHER_TEXT'))"
        :rules="'required'"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :maxlength="MAX_LENGTH"
          :label="$t('ETAB.FORMS.LABELS.ORIGINS.@OTHER_TEXT')"
          type="text"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </div>
  </div>
</template>

<script>
  import { Field } from "vee-validate";
  import { SHORT_TEXT_LENGTH_LIMIT } from "@core/constants";

  const OTHER = "other";
  export default {
    components: {
      Field,
    },
    props: {
      origin: { type: String, default: "" },
      otherValue: { type: String, default: "" },
      inputValues: { type: Array, default: () => [] },
    },
    emits: ["update:otherValue", "update:origin"],
    data() {
      return {
        MAX_LENGTH: SHORT_TEXT_LENGTH_LIMIT,
      };
    },
    computed: {
      _origin: {
        get() {
          return this.origin;
        },
        set(value) {
          this.$emit("update:origin", value);
        },
      },
      _otherValue: {
        get() {
          return this.otherValue;
        },
        set(value) {
          this.$emit("update:otherValue", value);
        },
      },
    },
    created() {
      this.OTHER = OTHER;
    },
  };
</script>
